import { AxiosInstance } from '../../helpers/AxiosInstance';
import Config from '../../config';

const CreateLiveChatChannel = (orgID: string, channel: number, data) => {
    return AxiosInstance.post(`${Config.FALKON_CONNECT_API}/api/v1/account/${orgID}/${channel}`, data)
}//create a live chat channel

const EditLiveChatChannel = (orgID: string, channelId: string, data) => {
    return AxiosInstance.put(`${Config.FALKON_CONNECT_API}/api/v1/account/${orgID}/livechat/${channelId}`, data)
}//edit live chat channel details

const GetLiveChatDetails = (ChannelId: string) => {
    return AxiosInstance.get(`${Config.FALKON_CONNECT_API}/api/v1/livechat/channel/details/${ChannelId}`)
}//get live chat details

const ValidateLiveChat = (channelId, url: { weburl: string }) => {
    return AxiosInstance.post(`${Config.FALKON_CONNECT_API}/api/v1/livechat/validate/${channelId}`, url)
} //validate livechat in a website

const GetLiveChatStatus = (channelId: { channelid: string }) => {
    return AxiosInstance.post(`${Config.FALKON_CONNECT_API}/api/v1/livechat/validate/channel`, channelId)
}//get live chat channel status

const sendLiveChatLoginUserDetails = (ChannelAccountId: string, user: {
    name: string
    username: string
    data: {
        device_id: string
    },
    custom_fields: {
        field_name: string,
        value: any
    }[]
}) => {
    return AxiosInstance.post(`${Config.FALKON_CONNECT_API}/api/v1/livechat/${ChannelAccountId}/create/login/user`, user)
}// login in live chat  with credentials

const AnonymousUserDetails = (ChannelAccountId: string, user: {
    data: {
        device_id: string,
    },
    nick_name: string
}) => {
    return AxiosInstance.post(`${Config.FALKON_CONNECT_API}/api/v1/livechat/${ChannelAccountId}/create/anonymous/user`, user)
} // login as a live chat anonymous user

const getLiveChatHistoryByLatestSession = (Participant_Id: string, Latest_Session: number) => {
    return AxiosInstance.get(`${Config.FALKON_CONNECT_API}/api/v1/livechat/history/${Participant_Id}/${Latest_Session}`)
}// get live chat conversation history in widget

const ClearLiveChatSession = (Participant_Id: string, Latest_Session: number) => {
    return AxiosInstance.patch(`${Config.FALKON_CONNECT_API}/api/v1/livechat/refresh/session/${Participant_Id}/${Latest_Session}`)
}// to update latest session and clear current conversation

const EndLiveChatSession = (Participant_Id: string) => {
    return AxiosInstance.patch(`${Config.FALKON_CONNECT_API}/api/v1/livechat/close/chat/${Participant_Id}`)
}// to end the current session and log out

const CheckLiveChatActiveUser = (ChannelId: string, DeviceId: string) => {
    return AxiosInstance.get(`${Config.FALKON_CONNECT_API}/api/v1/livechat/participant/${ChannelId}/${DeviceId}`)
}// to check whether the live chat user end chat or not

const GetClientToken = (deviceId) => {
    return AxiosInstance.get(`${Config.FALKON_CONNECT_API}/api/v1/token/generate/${deviceId}`)
} // get a client token based on device id for livechat grpc connection establishment

const ReceiveLiveChatMessage = (data: {
    sender: {
        id: string
    },
    recipient: {
        id: string
    },
    messagebody: {
        text: string
    }
}) => {
    return AxiosInstance.post(`${Config.FALKON_CONNECT_API}/api/v1/livechat/webhook/message`, data)
} //send live chat message from widget to falkon sms app

function ReceiveLiveChatMedia(participantID: string, mediatype: string, data: any) {
    return AxiosInstance.post(`${Config.FALKON_CONNECT_API}/api/v1/livechat/mms/${mediatype}/${participantID}/`, data)
} //send live chat media from widget to falkon sms app


const deleteLiveChatMessages = (Participant_Id: string) => {
    return AxiosInstance.delete(`${Config.FALKON_CONNECT_API}/api/v1/livechat/messages/${Participant_Id}`)
} //delete all livechat messages

// const WelcomeMessageStatus = (Participant_Id: string) => {
//     return AxiosInstance.delete(`${Config.FALKON_CONNECT_API}/api/v1/account/:tenantId/:channelId/welcome/:status`)
// } //delete all livechat messages

const addChannelTemplate = (orgID, channelType, data) => {
    return AxiosInstance.post(`${Config.FALKON_CONNECT_API}/api/v1/template/${orgID}/add/${channelType}`, data)
}

const sendChatTranscript = (Participant_Id: string, Latest_Session: number) => {
    return AxiosInstance.post(`${Config.FALKON_CONNECT_API}/api/v1/livechat/transcript/${Participant_Id}/${Latest_Session}`)
}

const deliverdMessageStatus = (data: {
    time: number,
    recipient: {
        id: string
    },
    sender: {
        id: string
    }
}) => {
    return AxiosInstance.post(`${Config.FALKON_CONNECT_API}/api/v1/livechat/webhook/delivery`, data)
}// to check whether the live chat user end chat or not

const ReadMessageStatus = (data: {
    time: number,
    recipient: {
        id: string
    },
    sender: {
        id: string
    }
}) => {
    return AxiosInstance.post(`${Config.FALKON_CONNECT_API}/api/v1/livechat/webhook/read`, data)
}

const UpdateUserNotificationSounds = (userId: string, sound_enabled: boolean
) => {
    return AxiosInstance.post(`${Config.FALKON_CONNECT_API}/api/v1/livechat/participant/${userId}/sound`, { "sound_enabled": sound_enabled })
}

const ChatRating = (participantID: string, data: any) => {
    return AxiosInstance.post(`${Config.FALKON_CONNECT_API}/api/v1/livechat/rating/${participantID}`, data)
}

const WordpressLiveChatValidation = (channelId: string, data: any) => {
    return AxiosInstance.post(`${Config.FALKON_CONNECT_API}/api/v1/livechat/validate/plugin/${channelId}`, data)
}

export const LiveChatService = {
    ValidateLiveChat,
    sendLiveChatLoginUserDetails,
    AnonymousUserDetails,
    getLiveChatHistoryByLatestSession,
    ClearLiveChatSession,
    EndLiveChatSession,
    CreateLiveChatChannel,
    ReceiveLiveChatMessage,
    ReceiveLiveChatMedia,
    GetLiveChatStatus,
    GetClientToken,
    deleteLiveChatMessages,
    CheckLiveChatActiveUser,
    addChannelTemplate,
    EditLiveChatChannel,
    GetLiveChatDetails,
    sendChatTranscript,
    deliverdMessageStatus,
    ReadMessageStatus,
    UpdateUserNotificationSounds,
    ChatRating,
    WordpressLiveChatValidation,
}